import React, { Component } from 'react'
import { Space, Input, Button } from 'antd';
import { SmileTwoTone, HeartTwoTone, CheckCircleTwoTone } from '@ant-design/icons';

export default class opening_stock_item extends Component {
  constructor(props){
    super(props)
    this.state = {
      cost: this.props.defaultCost
    }
  }
  changeQty = ({ target }) => {

    this.setState({ qty: target.value, changed: true });

  }

  changeCostPrice = ({target}) => {
    this.setState({ cost: target.value, changed: true  });
  }

  trySaving = () => {
    const { qty, cost } = this.state

    const stockLocation = window['stockLocation']
    const date = window['date']
    const { time, variantId } = this.props
    // debugger
    if (cost && qty && stockLocation && date)
    {
      const opts = {
        qty, cost, time, time, stockLocation, variantId, date
      }
      this.setState({loading: true})
      const $this = this;
      $.ajax({
        type: "POST",
        dataType: 'json',
        url: '/stocks/opening_stock_item',
        data: {
          ...opts, token: Spree.api_key
        },
        success: function () {
          console.log("opening stock saved")
          console.log("SUCCESS")
          $this.setState({ saved: true, changed: false })
        },
        
      }).done(function () {
        console.log("DONE")
        $this.setState({ loading: false  })
      });;

    }
    else{
      alert(`cost: ${cost}. qty: ${qty}. stockLocation: ${stockLocation}. date: ${date}. Whats missing?`)

    }
    
  }
  shouldDisable = () => {
    return false
  }
  

  render() {
    const { defaultCost } = this.props
    const { saving, saved, changed  } = this.state
    return (
      <div>
        <Space>
          <Input  onChange={this.changeQty} 
            placeholder="Qty"/>
          <Input defaultValue={defaultCost} onChange={this.changeCostPrice} placeholder="Cost" />
          <Button onClick={this.trySaving} loading={saving}>Save</Button>

          {
            !changed && saved ? (
              <CheckCircleTwoTone twoToneColor="#52c41a" />
            ) : ''}
          {
            changed ?
              (<SmileTwoTone />)
            :
            ('')
          }
          
          {/* <HeartTwoTone twoToneColor="#eb2f96" /> */}

        </Space>
      </div>
    )
  }
}
